/* ducks-n-stuff — hero slideshow ==========================================
   Cross-fades photographs behind the paper card. Pauses on hover, on focus,
   when the tab is hidden and for anyone who prefers reduced motion.
   ========================================================================= */

class DnsHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-dns-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-dns-slide-to]'));
    if (this.slides.length < 2) return;

    this.index = 0;
    this.paused = false;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.show(Number(dot.dataset.dnsSlideTo));
        this.restart();
      });
    });

    this.addEventListener('mouseenter', () => (this.paused = true));
    this.addEventListener('mouseleave', () => (this.paused = false));
    this.addEventListener('focusin', () => (this.paused = true));
    this.addEventListener('focusout', () => (this.paused = false));

    if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.restart();
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  restart() {
    clearInterval(this.timer);
    const seconds = Number(this.dataset.interval) || 6;
    this.timer = setInterval(() => {
      if (this.paused || document.hidden) return;
      this.show((this.index + 1) % this.slides.length);
    }, seconds * 1000);
  }

  show(next) {
    this.slides[this.index].classList.remove('is-current');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.dots[this.index]?.setAttribute('aria-current', 'false');

    this.index = next;

    this.slides[this.index].classList.add('is-current');
    this.slides[this.index].removeAttribute('aria-hidden');
    this.dots[this.index]?.setAttribute('aria-current', 'true');
  }
}

if (!customElements.get('dns-hero')) customElements.define('dns-hero', DnsHero);
